export function getResendSecondsLeft(
  resendAvailableAt: string | null | undefined,
  nowMs: number,
): number {
  if (!resendAvailableAt) return 0;

  const availableAt = Date.parse(resendAvailableAt);
  if (Number.isNaN(availableAt)) return 0;

  return Math.max(0, Math.ceil((availableAt - nowMs) / 1000));
}

export function formatResendCountdown(secondsLeft: number): string {
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}
